import { useEffect } from 'react';
import { ClientSidebar } from '@ecosystem/newron-client-lib';

export const useSidebar = (key: string) => {
  const { expanded, toggleSidebar, openSidebar, hideSidebar } = ClientSidebar.useSidebar({ key });

  useEffect(() => {
    if (expanded) {
      const trayWidth = document.documentElement.style.getPropertyValue('--right-sidebar-width');
      if (trayWidth === '0px') {
        // Only toggle if it's not already expanding
        hideSidebar();
        toggleSidebar();
      }
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }, [expanded, toggleSidebar, hideSidebar]);

  return { expanded, toggleSidebar, openSidebar, hideSidebar };
};
